export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.5-1621.06",
  commitId: "76f6a2e280b4a07f22d15fcbb822bcbccbf76338",
  commitTime: "2026-08-05T16:21:06.000Z",
});
